<div class="home-bg">
</div>
<div id="outer_container">
    <div class="container-fluid noPadding">
    <!-- uiView: content -->
        <div
            id="content"
            ui-view="content"
            class="angular-animate ng-scope"
            autoscroll="true"
            mtc-scroll-to-invalid=""
        >
            <!-- video controls -->
            <!-- <div class="video-control">
                <button id="myBtn" class="btn2 btn2-light" onclick="myFunction()"></button>
            </div> -->
            <!-- video controls -->
            <div class="ng-scope">
            <div class="container">
                <div class="home">
                    <div class="type-container ng-scope">
                        <div class="type-copy">
                            <p><strong>Registration will begin on Wednesday, November 18, 2026.</strong></p>
                            <p>Please refer to your invitation for the registration link to join us in Monte Carlo, Monaco, 
                                on the French Riviera March 15-20, 2027. Your registration must be completed no later than Friday, January 8, 2027.</p>

                            <p>Should you have any questions or require assistance with your registration, please contact <strong>Golden Eagle Travel Headquarters:</strong><br>
                            <strong>Phone: </strong> <a href="+18842161698">+ 1 884-216-1698</a> (Toll free in the U.S. and Canada) or 
                            <a href="+16368270149">+1 636-827-0149</a> (International)<br>
                            <strong>Email: </strong> <a href="mailto:GEC2027MonteCarlo@travelhq.com">GEC2027MonteCarlo@travelhq.com</a><br>
                            <strong>Hours: </strong> 8:00 AM - 4:00 PM Central time</p>

                            <p>Before registering, please review the FAQ section for answers to common questions about the trip.</p>

                            <p>We look forward to celebrating your success!</p>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
